'use strict';

module.exports = function pull(key) {
  var value = this.items[key] || null;
  delete this.items[key];
  return value;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/pull.js
// module id = 1258
// module chunks = 2